import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MARKETS } from "../constants";
import { useLang } from "../i18n";
import { useQuote } from "../quote";

export default function Markets() {
  const { t } = useLang();
  const { openDrawer } = useQuote();

  return (
    <section id="wholesale" className="border-t border-gold/15 bg-cellar/60 px-6 py-28 md:px-12 md:py-40" data-testid="wholesale">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8 }}
            className="text-[0.65rem] uppercase tracking-[0.5em] text-gold"
          >
            {t("markets.eyebrow")}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ delay: 0.1, duration: 0.8 }}
            className="font-display text-carved-ivory mt-6 text-4xl md:text-6xl"
          >
            {t("markets.title")}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="mt-8 max-w-lg text-lg leading-relaxed text-parchment/75"
          >
            {t("markets.body")}
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ delay: 0.25, duration: 0.8 }}
            className="mt-4 max-w-lg text-lg leading-relaxed text-parchment/75"
          >
            {t("markets.body2")}
          </motion.p>
          <motion.button
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            onClick={openDrawer}
            data-testid="partner-cta-button"
            className="btn-gold mt-10"
          >
            {t("markets.cta")} <ArrowRight size={15} />
          </motion.button>
        </div>

        <div className="lg:col-span-7">
          {MARKETS.map((m, i) => (
            <motion.div
              key={m.name}
              data-testid={`market-row-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: i * 0.06, duration: 0.7 }}
              className="group flex items-baseline justify-between border-b border-gold/10 py-5 transition-all duration-300 first:border-t hover:border-gold/40 hover:px-3 md:py-6"
            >
              <span className="flex items-baseline gap-6">
                <span className="text-[0.6rem] tracking-[0.3em] text-stone">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display text-2xl text-parchment transition-colors duration-300 group-hover:text-gold md:text-4xl">
                  {m.name}
                </span>
              </span>
              <span className="text-sm text-stone transition-colors duration-300 group-hover:text-gold/80 md:text-base">
                {m.native}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
